import React, { useEffect, useState, useRef, useMemo } from "react";
import { useAppDispatch } from "../redux/hooks";
import { LuTrash } from "react-icons/lu";
import { setBreadcrumb } from "../redux/slices/breadCrumb.slice";
import { BsFiletypeSvg } from "react-icons/bs";
import Retry from "../svg/retry";
import DeleteModal from "./modals/DeleteModal";
import EditIcon from "../svg/editIcon";
import "./styles/common.css";
import {
  MultiSelect,
  Checkbox,
  Switch,
  Modal,
  Tooltip,
  Loader,
  Button,
} from "@mantine/core";
import * as Yup from "yup";
import { GoQuestion } from "react-icons/go";
import { Formik, ErrorMessage, yupToFormErrors } from "formik";
import { useNavigate } from "react-router-dom";
import { notifications } from "@mantine/notifications";
import {
  useEditFloorDataMutation,
  useLazyGetS3UrlQuery,
} from "../redux/slices/api.slice";
import { useParams } from "react-router-dom";

import { IoCloudUploadOutline } from "react-icons/io5";
import {
  editFloorData,
  resetGetFloorsStatus,
} from "../redux/slices/groups.slice";
import api from "../redux/slices/api.slice";
import { useLazyGetFloorQuery } from "../redux/slices/api.slice";
import { useFormikContext } from "formik";
import {
  useGetLocationsQuery,
  useGetFloorsQuery,
} from "../redux/slices/api.slice";
import { useDeleteFloorMutation } from "../redux/slices/api.slice";
import { deleteFloor } from "../redux/slices/groups.slice";
import { favoritesLocsAndFloors } from "../interfaces/bookmarks";
import { useGetFavorites } from "../hooks/useGetFavorites";
import Container from "./Container";

const EditFloor = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [floor, setFloor] = useState(null);
  const [favorites, setFavorites] = useGetFavorites<favoritesLocsAndFloors>(
    "favorite-locations/floor",
    { locations: [], floors: {} }
  );

  const [getFloor, { isLoading }] = useLazyGetFloorQuery();
  const { id, GrpId } = useParams();

  const { data: groups } = useGetLocationsQuery("");
  const cloud = process.env.REACT_APP_CLOUDFRONT_URL;

  const [fetchS3URL] = useLazyGetS3UrlQuery();

  const [updateFloors, { isLoading: isLodingEditFloorData }] =
    useEditFloorDataMutation();
  const [isloadingImg, setIsLoadingImg] = useState(false);
  const [isErrorImg, setIsErrorImg] = useState(false);
  const [svgSize, setSvgSize] = useState(0);
  const imgRef = useRef(null);
  const [deleteFloorMutation, { isLoading: isLoadingDelete }] =
    useDeleteFloorMutation();

  useEffect(() => {
    const fetchFloor = async () => {
      const { data } = await getFloor(id);
      setFloor(data);
    };
    fetchFloor();
  }, [id]);

  const handleEditFloors = async (values) => {
    try {
      const response = await updateFloors({
        floorID: floor?.id,
        floorData: {
          name: values.name,
          svgURL: values.svgURL,
          amenities: values.amenities,
          position: values.position,
        },
        requestType: "updateData",
      });
      //@ts-ignore
      if (response.data) {
        dispatch(api.util.invalidateTags(["FavFloors"]));
        dispatch(api.util.invalidateTags(["Locations"]));
        dispatch(api.util.invalidateTags(["Location"]));
        dispatch(
          editFloorData({
            floorID: floor?.id,
            name: values.name,
            svgURL: values.svgURL,
            live: values.live ? true : false,
            amenities: values.amenities,
            position: values.position,
          })
        );

        notifications.show({
          title: "Success",
          message: "Floor edited successfuly",
          color: "green",
        });
      } else {
        notifications.show({
          title: "Error",
          message: "something went wrong , try again!",
          color: "red",
        });
      }
    } catch (e) {
      notifications.show({
        title: "Error",
        message: "something went wrong , try again!",
        color: "red",
      });
    }
    navigate(`/Location/${floor.locationID}`);
  };
  const handleChangeFloorStatus = async (live) => {
    try {
      const response = await updateFloors({
        floorID: floor?.id,
        floorData: {
          live: live ? true : false,
        },
        requestType: "toggleLive",
      });
    } catch (e) {
      console.log("error", e);
    }
  };
  const getSvgFileSize = async (url) => {
    try {
      const response = await fetch(url, { method: "HEAD" });

      if (response.ok) {
        const contentLength = response.headers.get("Content-Length");

        if (contentLength) {
          return parseInt(contentLength, 10);
        } else {
          throw new Error("Content-Length header is not available");
        }
      } else {
        throw new Error(`Failed to fetch the URL: ${response.statusText}`);
      }
    } catch (error) {
      console.error("Error fetching the URL:", error);
      return null;
    }
  };

  const removeFavoriteFloor = () => {
    setFavorites((prev) => {
      const floorsInLoc = prev.floors?.[floor.locationID]?.filter(
        (item) => item !== floor.id
      );
      if (floorsInLoc) {
        if (floorsInLoc.length > 0) {
          return {
            ...prev,
            floors: {
              ...prev.floors,
              [floor.locationID]: floorsInLoc,
            },
          };
        } else {
          const { [floor.locationID]: _, ...updatedFloors } = prev.floors;
          return {
            ...prev,
            floors: updatedFloors,
          };
        }
      }
      return prev;
    });
  };
  const handleFloorDelete = async () => {
    try {
      const result = await deleteFloorMutation({ floorID: floor.id });
      //@ts-ignore
      if (result.data) {
        removeFavoriteFloor();
        dispatch(api.util.invalidateTags(["Locations"]));
        dispatch(
          deleteFloor({
            floorID: floor.id,
          })
        );
        // dispatch(resetGetFloorsStatus({ locationID: GrpId }));
        notifications.show({
          title: "Success",
          message: "Floor deleted successfuly",
          color: "green",
        });
      } else {
        notifications.show({
          title: "Error",
          message: "Error deleting floor",
          color: "red",
        });
      }
    } catch (err) {
      notifications.show({
        title: "Error",
        message: "Floor deleted successfuly",
        color: "red",
      });
    }
    navigate(`/Location/${floor.locationID}`);
  };

  const handleEditImage = async (e, setFieldValue, valueName) => {
    const file = e.target.files;
    const sizeInBytes = file[0]?.size
      ? Number((file[0].size / 1024).toFixed(1))
      : 0;
    setSvgSize(sizeInBytes);
    const timestamp = Math.floor(new Date().getTime() / 1000);
    const fileName = file[0].name.split(".")[0];
    const ext = file[0].name.split(".")[1];
    imgRef.current = { name: file[0].name, size: file[0].size };
    try {
      setIsLoadingImg(true);
      setIsErrorImg(false);
      const { data: URL } = await fetchS3URL({
        fileName: `${fileName}-${timestamp}.${ext}`,
      });
      const res = await fetch(URL, {
        method: "PUT",
        body: file[0],
      });

      if (res.ok) {
        setFieldValue(valueName, `${cloud}${fileName}-${timestamp}.${ext}`);

        setIsLoadingImg(false);
      } else {
        setFieldValue(valueName, "");
        setIsErrorImg(true);
      }
    } catch (e) {
      console.log("err", e);
      setIsLoadingImg(false);
      setIsErrorImg(true);
    }
  };

  const initialValues = {
    name: "",
    svgURL: "",
    live: "",
    amenities: [],
  };

  const validationSchema = Yup.object().shape({
    name: Yup.string().required("This field is required"),
    live: Yup.string(),
    position: Yup.number().min(0, "The number must be positive"),
    svgURL: Yup.string().test(
      "is-svg",
      "Unsupported format, only SVGs allowed",
      (value) => !value || value.endsWith(".svg")
    ),
  });

  useEffect(() => {
    const currentLocGrp = groups?.find((l: any) => l.id === GrpId);
    const crumbs = [
      { name: "Home", route: "/" },
      {
        name: currentLocGrp?.name,
        route: `/Location/${currentLocGrp?.id}`,
      },
      { name: "Edit Floor", route: "" },
    ];
    dispatch(setBreadcrumb(crumbs));
  }, [dispatch, groups, GrpId]);

  if (isLoading) {
    return (
      <div className="w-full h-[90vh] flex items-center justify-center">
        <Loader size="xl" />
      </div>
    );
  }

  return (
    <Container>
      <div className="relative ">
        <Formik
          initialValues={initialValues}
          onSubmit={(values, helpers) => {
            handleEditFloors(values);
          }}
          validationSchema={validationSchema}
        >
          <Form
            id={id}
            handleEditImage={handleEditImage}
            floor={floor}
            isloadingImg={isloadingImg}
            isErrorImg={isErrorImg}
            imgRef={imgRef}
            handleFloorDelete={handleFloorDelete}
            isLoadingDelete={isLoadingDelete}
            isLodingEditFloorData={isLodingEditFloorData}
            svgSize={svgSize}
            setSvgSize={setSvgSize}
            getSvgFileSize={getSvgFileSize}
            setIsErrorImg={setIsErrorImg}
            setIsLoadingImg={setIsLoadingImg}
            handleChangeFloorStatus={handleChangeFloorStatus}
          />
        </Formik>
      </div>
    </Container>
  );
};

export default EditFloor;

const Form = ({
  id,
  handleEditImage,
  handleFloorDelete,
  isErrorImg,
  setIsErrorImg,
  setIsLoadingImg,
  floor,
  isloadingImg,
  imgRef,
  isLoadingDelete,
  isLodingEditFloorData,
  svgSize,
  setSvgSize,
  getSvgFileSize,
  handleChangeFloorStatus,
}) => {
  type MyFormValues = {
    [key: string]: any;
  };
  const {
    values,
    errors,
    touched,
    handleChange,
    handleBlur,
    handleSubmit,
    isSubmitting,
    setFieldValue,
  } = useFormikContext<MyFormValues>();
  const amenitiesData = [
    "Wi-Fi Available",
    "Coffee Space",
    "Meetings Room",
    "Printers",
    "Wheelchair Accessible",
    "Pet-friendly",
    "Lounge Area",
    "Quiet Zones",
  ];

  const cloud = process.env.REACT_APP_CLOUDFRONT_URL;

  useEffect(() => {
    setFieldValue("name", floor?.name);
    setFieldValue("svgURL", floor?.svgURL);
    setFieldValue("live", floor?.live);
    setFieldValue("capacity", floor?.capacity);
    setFieldValue("position", floor?.position);
    setFieldValue("amenities", floor?.amenities || []);
    floor?.svgURL &&
      getSvgFileSize(floor.svgURL).then((sizeInBytes) => {
        if (sizeInBytes !== null) {
          setSvgSize(Number(sizeInBytes / 1024).toFixed(1));
        }
      });
  }, [id, floor]);

  const [openModal, setOpenModal] = useState(false);
  const handleDeleteSVG = () => {
    setFieldValue("svgURL", "");
    imgRef.current = null;
    setSvgSize(0);
    setIsErrorImg(false);
    setIsLoadingImg(false);
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="flex sticky py-4 z-40 top-0 w-full bg-white justify-between  gap-4 xl:gap-0 items-start xl:items-center xl:flex-row flex-col">
        <h2 className="text-3xl xl:text-5xl  font-md"> Floor Settings</h2>
        <div className="flex gap-6 items-center">
          <Button
            type="submit"
            color="#FB6514"
            loading={isLodingEditFloorData}
            disabled={isSubmitting}
            radius={"xl"}
            size="md"
          >
            {values.live ? "Save & Set Live " : "Save Changes"}
          </Button>
        </div>
      </div>

      <div className="grid pb-[50px] grid-cols-1 xl:grid-cols-2 xl:gap-14 gap-10 xl:w-[85%]  w-full  mx-auto xl:mt-20 mt-10 ">
        <div className="flex-col flex gap-2  ">
          {/* title , desc , placholder , name ,inpType  */}
          <h2 className="font-medium text-xl text-grayText ">Floor Name</h2>
          <p className="text-grayText2 text-base">
            This will be displayed as the floor plan.
          </p>
        </div>
        <div className="flex flex-col gap-2 ">
          <input
            type="text"
            name="name"
            value={values.name}
            className={`${
              errors.name && touched.name
                ? "border-alert "
                : "border-lightGray2"
            } h-10  rounded-lg px-4 border-1 w-full  border-solid focus:outline-none focus:border-grayText3  placeholder:text-lightGray2`}
            placeholder="Floor Name"
            onChange={handleChange}
          />
          <ErrorMessage
            name="name"
            component="div"
            className="text-alert text-xs"
          />
        </div>
        <div className="flex-col flex gap-2 w-[90%] ">
          <h2 className="font-medium text-xl text-grayText ">Floor Position</h2>
          <p className="text-grayText2 text-base">
            This is the floor number in the building.
          </p>
        </div>
        <div className="flex flex-col gap-2 ">
          <input
            type="number"
            name="position"
            value={values.position}
            className={`${
              errors.position && touched.position
                ? "border-alert "
                : "border-lightGray2"
            } h-10  rounded-lg px-4 border-1 w-full  border-solid focus:outline-none focus:border-grayText3  placeholder:text-lightGray2`}
            placeholder="Floor Position"
            onChange={handleChange}
            min={0}
          />
          <ErrorMessage
            name="position"
            component="div"
            className="text-alert text-xs"
          />
        </div>
        <div className="flex-col flex gap-2 w-[90%] ">
          <h2 className="font-medium text-xl text-grayText ">Amenities</h2>
          <p className="text-grayText2 text-base">
            Select all amenities that a floor can have
          </p>
        </div>
        <MultiSelect
          data={amenitiesData}
          value={values.amenities}
          onChange={(val) => setFieldValue("amenities", val)}
          withScrollArea={false}
          clearable
          styles={{
            dropdown: {
              maxHeight: 180,
              overflowY: "auto",
              borderColor: "#BBC3CF",
            },
            input: { borderRadius: "8px", borderColor: "#BBC3CF" },
          }}
        />
        <div className="flex-col flex gap-2 w-[90%] ">
          <h2 className="font-medium text-xl text-grayText ">Floor SVG</h2>
          <p className="text-grayText2 text-base">
            This will be displayed as the floor plan.
          </p>
        </div>
        <div className="flex flex-col gap-2 ">
          <div
            className={` min-h-24  relative  w-full flex-col flex  items-center  border border-solid   justify-center  rounded-md  py-4 px-2 ${
              (errors.svgURL && touched.svgURL) || isErrorImg
                ? "border-alert"
                : "border-lightGray2"
            }   `}
          >
            {!values.svgURL && !isErrorImg && (
              <input
                type="file"
                name="svgURL"
                accept="image/svg"
                onChange={(e) =>
                  e.target.files && handleEditImage(e, setFieldValue, "svgURL")
                }
                className="absolute  inset-0 opacity-0 sm:text-base text-sm  "
              />
            )}
            {isloadingImg && !isErrorImg ? (
              <p className="text-grayText3">
                uploading image<span className="loading">...</span>
              </p>
            ) : isErrorImg ? (
              <ErrorUploadingSvg
                svgSize={svgSize}
                fileName={imgRef.current?.name}
                handleDelete={handleDeleteSVG}
                handleEdit={handleEditImage}
                setFieldValue={setFieldValue}
              />
            ) : values.svgURL || imgRef.current ? (
              <SvgContent
                cloud={cloud}
                svgSize={svgSize}
                values={values}
                fileName={imgRef.current?.name}
                handleDelete={handleDeleteSVG}
                handleEdit={handleEditImage}
                setFieldValue={setFieldValue}
              />
            ) : (
              <UploadSVG />
            )}
          </div>

          <ErrorMessage
            name="svgURL"
            component="div"
            className="text-alert text-xs"
          />
        </div>
        <div className="flex-col flex gap-2 w-[90%] ">
          <h2 className="font-medium text-xl text-grayText ">Floor Status</h2>
          <p className="text-grayText2 text-base">
            Set the Floor to 'Live' and save to make it visible to users. This
            step confirms it's ready for use and ensures accurate display.
          </p>
        </div>
        <div className="flex gap-6">
          <Switch
            size="md"
            value={values.live}
            label={values.live ? "Live" : "Draft"}
            name="live"
            onChange={(e) => {
              setFieldValue("live", e.target.checked);

              handleChangeFloorStatus(e.target.checked);
            }}
            checked={values.live ? true : false}
          />
          <Tooltip
            withArrow
            label={
              !values.live ? (
                <p>
                  Keep as 'Draft' to make changes not visible to users.
                  <br /> Switch to 'Live' when you're ready to publish.
                </p>
              ) : (
                <p>
                  Switch to 'Live' to make this floor visible to all users.
                  <br /> Only switch to 'Live' once all details are confirmed.
                </p>
              )
            }
          >
            <div>
              <GoQuestion />
            </div>
          </Tooltip>
        </div>
        <Button
          size="lg"
          onClick={() => setOpenModal(true)}
          disabled={!floor?.id}
          variant="outline"
          color="#404F65"
          className="!w-fit"
        >
          delete floor
        </Button>
        <DeleteModal
          openModal={openModal}
          handleClose={() => setOpenModal(false)}
          targetName={floor?.name}
          desc={
            <p className="text-lg mt-2 mb-6 text-grayText5 text-center">
              This will permanently delete
              <span className="font-md px-1 text-grayText7">{floor?.name}</span>
            </p>
          }
          handleDelete={handleFloorDelete}
          isLoading={isLoadingDelete}
        />
      </div>
    </form>
  );
};

const SvgContent = ({
  values,
  svgSize,
  cloud,
  handleDelete,
  fileName,
  handleEdit,
  setFieldValue,
}) => {
  const editRef = useRef(null);
  return (
    <div
      data-cy="svgURL" // TODO : update this when testing
      className="flex  items-center h-full w-full justify-between px-2"
    >
      <div className="flex items-center gap-4">
        <BsFiletypeSvg className="text-4xl" />

        <div>
          <p className="text-[17px]">
            {fileName ? fileName : values.svgURL?.split(cloud)[1]}{" "}
          </p>
          {svgSize > 0 && (
            <p className="text-grayText3 text-sm">{`${svgSize}KB`}</p>
          )}
        </div>
      </div>

      <div className="flex items-center gap-4">
        <input
          type="file"
          name="svgURL"
          ref={editRef}
          accept="image/svg"
          onChange={(e) =>
            e.target.files && handleEdit(e, setFieldValue, "svgURL")
          }
          className="hidden "
        />
        <div
          onClick={() => {
            editRef.current.click();
          }}
          className="cursor-pointer flex justify-center"
        >
          <EditIcon />
        </div>

        <LuTrash
          className="text-xl cursor-pointer text-grayText3"
          onClick={(e) => {
            handleDelete();
          }}
        />
      </div>
    </div>
  );
};

const UploadSVG = () => {
  return (
    <>
      <div
        style={{ border: "6px solid #F7F8F9" }}
        className="flex justify-center items-center rounded-[50%] w-12 h-12 bg-lightGray my-2"
      >
        <IoCloudUploadOutline className="text-grayText text-xl" />
      </div>

      <p className="text-action pr-1 text-base font-medium  ">
        Click to upload
      </p>

      <p className="text-grayText2 text-sm">{`SVG (max. 800x400px)`}</p>
    </>
  );
};

const ErrorUploadingSvg = ({
  svgSize,
  handleDelete,
  fileName,
  handleEdit,
  setFieldValue,
}) => {
  const editRef = useRef(null);

  return (
    <div className="flex  items-center h-full w-full justify-between px-2">
      <div className="flex items-center gap-4">
        <BsFiletypeSvg className="text-4xl text-alert" />

        <div>
          <p className="text-[17px] text-alert">{fileName}</p>
          {svgSize > 0 && (
            <p className="text-alert text-sm">{`${svgSize}KB`}</p>
          )}
        </div>
      </div>
      <div className="flex gap-8 items-center">
        <p className="text-base italic text-grayText3">Upload Failed</p>

        <div className="flex items-center gap-4">
          <input
            type="file"
            name="svgURL"
            ref={editRef}
            accept="image/svg"
            onChange={(e) =>
              e.target.files && handleEdit(e, setFieldValue, "svgURL")
            }
            className="hidden "
          />
          <div
            onClick={() => {
              editRef.current.click();
            }}
            className="cursor-pointer flex justify-center"
          >
            <Retry fill={"#4D5F7A"} width={18} height={18} />
          </div>

          <LuTrash
            className="text-xl cursor-pointer text-grayText3"
            onClick={(e) => {
              handleDelete();
            }}
          />
        </div>
      </div>
    </div>
  );
};
